// Turbo frame-missing recovery for the practice answer form.
//
// A frame-scoped form submission whose response does not contain the matching
// <turbo-frame> makes Turbo discard the response and paint its default
// "Content missing" text into the frame, stranding the learner with no way
// forward but a manual reload.
//
// In production this is overwhelmingly a 422 from an expired CSRF token after a
// tab sat idle long enough for the session cookie to be dropped/rotated (so the
// form's authenticity_token no longer matches the session), plus a minority of
// transient origin 5xx (502/500/520). See Sentry SKILLOUT-PRODUCTION-7H / -BF —
// 1200+ occurrences, all on /test_modes/*/test_practice. Turbo's own console
// error even prescribes the cure: "To perform a full page visit instead, set
// turbo-visit-control to reload."
//
// Recover by reloading: the fresh page carries a current CSRF token and a
// re-validated session (or redirects to sign-in if the user is genuinely logged
// out), so they land on a working question instead of a dead end. A hard reload
// is used rather than Turbo's detail.visit(detail.response) because the response
// URL is the POST endpoint (/test_result_items), which is not GET-navigable.
const RELOAD_GUARD_KEY = "frameMissingReloadAt"
const RELOAD_GUARD_MS = 5000

document.addEventListener("turbo:frame-missing", (event) => {
  if (event.target?.id !== "test-results-form") return

  // Guard against a pathological reload loop: if we already auto-reloaded a
  // moment ago, let Turbo's default ("Content missing") show instead of looping.
  const now = Date.now()
  const last = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) || 0)
  if (now - last < RELOAD_GUARD_MS) return

  event.preventDefault()
  sessionStorage.setItem(RELOAD_GUARD_KEY, String(now))
  window.location.reload()
})
